module.exports = __webpack_public_path__ + "static/apple-iphone-xs-gold-07eb0fcafb9401063683b7e4a61880ee.png";